// extracted by mini-css-extract-plugin
export default {"logoutContainer":"Logout_logoutContainer__o3Rjf","logoutIcon":"Logout_logoutIcon__g+GoT"};